
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { MenuItem, SplitButtonModule, SelectItem } from 'primeng/primeng';

import { CUIActionRowGridColumn } from './cui-grid-row-action-columns';

import * as moment from 'moment';

@Component({
    selector: 'cui-grid-row-action',
    templateUrl: './cui-grid-row-action.component.html',

})
export class CUIGridRowActionComponent {
    @Input() columns: CUIActionRowGridColumn[] = [];
    @Input() contextMenu: MenuItem[] = [];
    @Input() licenseItems: SelectItem[] = [];
    @Input() data: any[] = [];
    @Input() identityColumn: string = 'id';
    @Input() rowsPerPage: number = 10;
    @Input() selection: any[] = [];
    @Input() totalRecords: number = 0;
    @Input() filterDelay: number = 300;
    @Input() enableCheckbox: boolean = true;
    @Input() enableContextMenu: boolean = true;
    @Input() disableblkRemovebtn: boolean = true;
    @Input() disableblkAddbtn: boolean = true;
    @Input() sortField: string;
    @Input() sortOrder: number = 1;
    @Output() onLazyLoad: EventEmitter<any> = new EventEmitter();
    @Output() selectionChange: EventEmitter<any> = new EventEmitter();
    @Output() onClick: EventEmitter<any> = new EventEmitter();
    @Output() onContextMenuSelect: EventEmitter<any> = new EventEmitter();
    @Output() onRowAction: EventEmitter<any> = new EventEmitter();
    @Output() onAddBulkLicense: EventEmitter<any> = new EventEmitter();
    @Output() onRemoveBulkLicense: EventEmitter<any> = new EventEmitter();
    @Output() onLoadLicensesByType: EventEmitter<any> = new EventEmitter();


    filterTimeout = null;
    globalFilter: string;
    selectionMode: string;
    selectedFilter: string;


    private licenseExpiryCutOfDate: Date = new Date('2115-01-01');

    ngOnInit(): void {
        this.selectionMode = this.enableCheckbox ? 'multiple' : 'single';
        this.selection = [];

    }

    /**
     * @function emits a onClick event to the implementing feature component when the button link is clicked
     * @returns void
     */
    emitClick(value: string): void {
        this.onClick.emit({ value: value });
    }


    /**
      * @function emits a onRowAction event to the implementing feature component
      * @returns void
      */
    emitOnRowAction(data, type): void {
        this.onRowAction.emit({ event: data, type: type });
    }

    emitAddBulkLicenseClick(type): void {
        this.onAddBulkLicense.emit(type);
    }
    emitRemoveBulkLicenseClick(type): void {
        this.onRemoveBulkLicense.emit(type);
    }

    emitLoadLicensesByType(type): void {
        this.onLoadLicensesByType.emit(type);
    }

    /**
     * @function emits a onLazyLoad event to the implementing feature component
     * @returns void
     */
    emitLazyLoad(event): void {
        clearTimeout(this.filterTimeout);
        this.filterTimeout = setTimeout(() => {
            this.onLazyLoad.emit({
                filter: this.globalFilter,
                first: event.first,
                rows: event.rows,
                sortField: event.sortField,
                sortOrder: event.sortOrder,
                type: this.selectedFilter
            });

            this.filterTimeout = null;
        }, this.filterDelay);
    }

    /**
     * @function emits a onSelectionChange event to the implementing feature component
     * @returns void
     */
    emitSelection(event): void {
        this.selectionChange.emit(event);




    }

    emitContextMenu(event): void {
        this.onContextMenuSelect.emit(event);
    }

    isSortable(sortable) {
        return sortable != null ? sortable : true;
    }
}



// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/shared/cui-grid-row-action/cui-grid-row-action.component.ts